import React from 'react';
import getConfig from 'next/config';
import { GetStaticProps } from 'next';
import BasicLayout from 'layout/Basic';
import Contact, { Props } from 'containers/Contact';
import { convertProps } from 'lib/parseAPIResponse';

export const ContactPage = ({ contact, ads }: Props): React.JSX.Element => (
    <BasicLayout ads={ads}>
        <Contact contact={contact} ads={ads} />
    </BasicLayout>
);

export const getServerSideProps: GetStaticProps = async () => {
    const { apiUrl } = getConfig().publicRuntimeConfig;

    return Promise.all([
        fetch(`${apiUrl}/public/api/about/pl`),
        fetch(`${apiUrl}/public/api/naszadsik?path=kontakt`)
    ]).then(async ([res1, res2]) => {
        const data = await res1.json();
        if (data.code === 404) {
            return {
                notFound: true
            };
        }
        const ads = await res2.json();
        return { props: { ...convertProps(ads), ...convertProps(data) } };
    });
};

export default ContactPage;
